import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { legShape } from 'constants/propTypes';
import useTimetableServicesQuery from 'components/queries/useTimetableServicesQuery';

import { findServiceStopFromTimetableServices } from 'utils/timetableServices';

import TimetableStopStatus from './TimetableStopStatus';

import { TimetableStatusLoading, TimetableStatusEmpty } from './TimetableStatus.style';

const TimetableStatus = ({ journey, origin = false, destination = false }) => {
  const {
    timing: { date },
    trainNumber
  } = journey;

  const destinationUic = journey.destination?.uic;
  const originUic = journey.origin?.uic;

  const [arrivalService, setArrivalService] = useState(null);
  const [departureService, setDepartureService] = useState(null);

  const { timetableServices, loading } = useTimetableServicesQuery({ date, destinationUic, originUic, trainNumber });

  useEffect(() => {
    if (timetableServices) {
      setArrivalService(findServiceStopFromTimetableServices({ timetableServices, uic: destinationUic }));
      setDepartureService(findServiceStopFromTimetableServices({ timetableServices, uic: originUic }));
    }
  }, [timetableServices, setArrivalService, setDepartureService, destinationUic, originUic]);

  if (loading) {
    return <TimetableStatusLoading data-testid="timetable-status-loading" />;
  }

  if (!timetableServices || !destinationUic || !originUic) {
    return <TimetableStatusEmpty data-testid="timetable-status-empty" />;
  }

  return (
    <>
      {origin && (
        <TimetableStopStatus
          serviceStatus={timetableServices?.[0]?.model?.serviceStatus}
          data-testid="timetable-stop-status-origin"
          serviceStop={departureService}
          departure
        />
      )}
      {destination && (
        <TimetableStopStatus
          serviceStatus={timetableServices?.[0]?.model?.serviceStatus}
          data-testid="timetable-stop-status-destination"
          serviceStop={arrivalService}
          arrival
        />
      )}
    </>
  );
};

TimetableStatus.propTypes = {
  journey: legShape.isRequired,
  // Display the origin and destination status
  origin: PropTypes.bool,
  destination: PropTypes.bool
};

export default TimetableStatus;
